module.exports = __webpack_public_path__ + "static/media/received_2403125593244918.04eb178f.jpeg";